module.exports = __webpack_public_path__ + "img/detail_en.cfc36a24.png";